/* eslint-disable no-console */
import { matches } from 'lodash';
import { ApolloLink, makeVar } from '@apollo/client';
import { isServer, isWorker } from '@frameio/utils/config/helpers';

const containsSubscription = matches({ operation: 'subscription' });

export const currentPreviewEnvironment = makeVar<string>('');

export default new ApolloLink((operation, forward) => {
  if (isServer || isWorker) {
    throw new Error(
      'We only need to check for BE Preview Environment in the client-side Apollo client.'
    );
  }

  // massdriver does not return the preview env headers on subscriptions, so we
  // should return early.
  if (operation.query.definitions.some(containsSubscription)) {
    return forward(operation);
  }

  return forward(operation).map((response) => {
    const context = operation.getContext();
    const responseHeaders = context?.response?.headers;
    const previewEnvironment = responseHeaders?.get('x-application-env');

    currentPreviewEnvironment(previewEnvironment);

    return response;
  });
});
